import ModalBasic from "Components/Modal/Modal";
import { ReactComponent as DeactivateIcon } from "Assets/Deactivate.svg";

export const InvalidatePdfModal = ({
  isModalOpen,
  isLoading,
  onInvalidate,
  onCancel,
  startDate,
  endDate,
}) => {
  const detailLine =
    startDate || endDate ? (
      <span className="block mt-2 text-sm text-gray-700">
        {startDate && <span className="font-medium">Start Date:</span>}{" "}
        {startDate || "N/A"}
        {"  |  "}
        {endDate && <span className="font-medium">End Date:</span>}{" "}
        {endDate || "N/A"}
      </span>
    ) : null;

  return (
    <ModalBasic
      icon={<DeactivateIcon />}
      btnText="Invalidate"
      heading="Invalidate PDF"
      content="Are you sure you want to invalidate this visit notes PDF? This action cannot be undone."
      open={isModalOpen}
      loading={isLoading}
      setOpen={(value) => {
        if (value === "Invalidate") {
          onInvalidate();
        } else {
          onCancel();
        }
      }}
    >
      {detailLine}
    </ModalBasic>
  );
};
